import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CertificateTableNamesEnum } from 'src/app/certificate-user/enums/certificate-table-names.enum';

@Component({
  selector: 'app-certificate-templates',
  templateUrl: './certificate-templates.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CertificateTemplatesComponent {
  @Input() specificTemplateName: string;
  @Input() columnName: string;
  @Input() element: any;
  @Input() buttonFunctions: { [key: string]: () => void };
  @Input() hideButtons: boolean;

  certificateTableNamesEnum = CertificateTableNamesEnum;
}
